function Pagination({ totalPages, currentPage, onPageChange }) {
if (totalPages === 0) {
        return null;
    }
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    let displayedPages = pageNumbers;

    if (totalPages > 3) {
        if (currentPage <= 2) {
            displayedPages = [...pageNumbers.slice(0, 3), "...", totalPages];
        } else if (currentPage >= totalPages - 1) {
            displayedPages = [1, "...", ...pageNumbers.slice(totalPages - 3, totalPages)];
        } else {
            displayedPages = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
        }
    }

    return (
        <div className="self-stretch justify-center items-center inline-flex">
            <div className="w-[122px] p-2 justify-center items-center flex">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-2 justify-center items-center gap-2.5 flex"
                >
                    <div className="text-sky-900 text-base font-medium usersfont-['Roboto', 'Arial', 'sans-serif'] leading-none tracking-wide">Previous</div>
                </button>
            </div>
            {displayedPages.map((number, index) => (
                <div
                    key={index}
                    className={`w-[42px] p-2 ${
                        number === currentPage ? "bg-white" : ""
                    } justify-center items-center flex`}
                >
                    {number === "..." ? (
                        // Render non-clickable ellipsis
                        <div className="text-sky-900 text-base font-medium usersfont-['Roboto', 'Arial', 'sans-serif'] leading-none tracking-wide">
                            ...
                        </div>
                    ) : (
                        // Render clickable page button
                        <button
                            onClick={() => onPageChange(number)}
                            className="px-2 justify-center items-center flex"
                        >
                            <div className="text-sky-900 text-base font-medium usersfont-['Roboto', 'Arial', 'sans-serif'] leading-none tracking-wide">
                                {number}
                            </div>
                        </button>
                    )}
                </div>
            ))}
            <div className="w-[91px] p-2 justify-center items-center flex">
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-2 justify-center items-center gap-2.5 flex"
                >
                    <div className="text-sky-900 text-base font-medium usersfont-['Roboto', 'Arial', 'sans-serif'] leading-none tracking-wide">Next</div>
                </button>
                <div className="w-6 h-6 relative" />
            </div>
        </div>
    );
}
export default Pagination;